module.exports = __webpack_public_path__ + "img/neumatica_e_hidraulica.3ce83093.jpg";